import { render } from "./BusinessServices.vue?vue&type=template&id=eff4fbfc"
import script from "./BusinessServices.vue?vue&type=script&lang=js"
export * from "./BusinessServices.vue?vue&type=script&lang=js"

import "./BusinessServices.vue?vue&type=style&index=0&id=eff4fbfc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__